import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import find from "lodash/find";
import map from "lodash/map";
import clone from "lodash/clone";
import submit from "submit-form";
import Modal from "../modal-new";
// Added for optimization tweaks, so as to not have as many arrow functions in render
import DuplicateModalFooter from "./duplicate-workout-components/DuplicateModalFooter";
import ProgressionCheckbox from "./duplicate-workout-components/ProgressionCheckbox";
import ProgressionInput from "./duplicate-workout-components/ProgressionInput";
import LoadProgression from "./duplicate-workout-components/LoadProgression";
import { getExerciseNamesList } from "../../utils/progression-filters";
import CustomFilters from "./duplicate-workout-components/CustomFilters";

class DuplicateWorkoutModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {
        exerciseId: get(context.locals, "query.exerciseId", ""),
        isExercise: get(context.locals, "query.isExercise", ""),
        cycle: get(context.locals, "params.cycleId", ""),
        program: get(context.locals, "query.program", ""),
        from: {
          week: get(context.locals, "query.week", ""),
          session: get(context.locals, "query.session", ""),
        },
        to: [],
      },
      progressions: {},
      checkedProgression: {
        loadProgression: false,
        rpeProgression: false,
        repsProgression: false,
        setsProgression: false,
      },
      checkedFilters: {
        allFilter: true,
        primaryFilter: false,
        secondaryFilter: false,
        assistantFilter: false,
        customFilter: [],
      },
      submited: false,
      loadSwitch: {
        percent: true,
        units: context.locals.activeUser.units === "imperial" ? "lb" : "kg",
      },
      viewFilters: false,
    };

    if (this.state.data.isExercise)
      this.exercise = find(context.locals.editExercises, {
        _id: this.state.data.exerciseId,
      });

    this.exercisesList = getExerciseNamesList(
      context.locals.editExercises || context.locals.activeExercises,
      context.locals.query
    );

    this.handleCheck = this.handleCheck.bind(this);
    this.handleFilters = this.handleFilters.bind(this);
    this.handleProgressionInput = this.handleProgressionInput.bind(this);
    this.toggleSelection = this.toggleSelection.bind(this);
    this.handleLoadSwitch = this.handleLoadSwitch.bind(this);
    this.updateCustomFilter = this.updateCustomFilter.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
  }

  handleDuplicate(e) {
    e.preventDefault();
    if (this.state.submited) return;
    this.setState({ submited: true });
    const { data, progressions, checkedFilters, loadSwitch } = this.state;
    const { isExercise, exerciseId, to } = data;

    // if its an exercise we use the exercise duplication method, else its a workout
    if (isExercise) {
      // in the calendar views the context has activeExercises, while in the program-editor,
      // we have access to editExercises, depending on which view we use the applicable one.
      const { editExercises, activeExercises, activeUserToRequest } =
        this.context.locals;
      const originalCycle = find(
        activeExercises ? activeExercises : editExercises,
        { _id: exerciseId }
      );

      const destination = to.map((dest) => {
        dest.progression = {
          progressionLoad:
            progressions[`${dest.week}_${dest.session}_progression_load`],
          progressionRpe:
            progressions[`${dest.week}_${dest.session}_progression_rpe`],
          progressionSets:
            progressions[`${dest.week}_${dest.session}_progression_sets`],
          progressionReps:
            progressions[`${dest.week}_${dest.session}_progression_reps`],
          progressionFilters: checkedFilters,
          loadSwitch,
        };
        return dest;
      });
      !destination.length && this.setState({ submited: false });
      submit("/actions/exercise/duplicate-send-to-other-workout", {
        method: "POST",
        body: {
          originalCycle,
          destination,
          user: activeUserToRequest._id,
        },
      });
    } else {
      const body = Object.assign({}, data);

      body.to = body.to.map((destination) => {
        destination.progression = {
          progressionLoad:
            progressions[
              `${destination.week}_${destination.session}_progression_load`
            ],
          progressionRpe:
            progressions[
              `${destination.week}_${destination.session}_progression_rpe`
            ],
          progressionSets:
            progressions[
              `${destination.week}_${destination.session}_progression_sets`
            ],
          progressionReps:
            progressions[
              `${destination.week}_${destination.session}_progression_reps`
            ],
          progressionFilters: checkedFilters,
          loadSwitch,
        };
        return destination;
      });

      if (this.context.locals.activeUser.organizationId) {
        body.user = this.context.locals.activeUserToRequest._id;
      }

      submit("/actions/cycle/program/duplicateWorkout/", {
        method: "POST",
        body,
      });
    }
  }

  shouldDisable({ week, order, exercises }) {
    const { from } = this.state.data;

    if (!exercises) return false;
    return Boolean(
      (from.session == order && from.week == week) || exercises.length
    );
  }

  toggleSelection({ target: { value } }) {
    const { data } = this.state;
    const { to } = data;
    const toStringified = map(to, (item) => JSON.stringify(item));
    const index = toStringified.indexOf(value);

    if (index > -1) {
      to.splice(index, 1);
    } else {
      to.push(JSON.parse(value));
    }
    this.setState({ data });
  }

  handleProgressionInput({ target: { name, value } }) {
    const {
      locals: { activeUserToRequest },
    } = this.context;
    const intensityMeasure = get(
      activeUserToRequest,
      "intensityMeasure",
      "rpe"
    );
    const progressions = clone(this.state.progressions);
    progressions[name] = Number(value);
    if (name.includes("rpe") && intensityMeasure === "rir") {
      progressions[name] = progressions[name] * -1;
    }
    this.setState((prevState) => Object.assign({}, { progressions }));
  }

  handleCheck({ target: { name, checked } }) {
    this.setState((prevState) => {
      let checkedProgression = Object.assign({}, prevState.checkedProgression);
      checkedProgression[name] = checked;
      return { checkedProgression };
    });
  }

  handleFilters({ target: { name, checked } }) {
    if (name === "allFilter") {
      this.setState({
        checkedFilters: {
          allFilter: true,
          primaryFilter: false,
          secondaryFilter: false,
          assistantFilter: false,
          customFilter: [],
        },
      });
    } else if (name === "customFilter") {
      this.setState({
        viewFilters: true,
      });
    } else {
      this.setState((prevState) => {
        let checkedFilters = Object.assign({}, prevState.checkedFilters);
        checkedFilters["allFilter"] = false;
        checkedFilters["customFilter"] = [];
        checkedFilters[name] = checked;
        return { checkedFilters };
      });
    }
  }

  updateCustomFilter(action, data) {
    switch (action) {
      case "check":
        // Custom filter checkbox checked, update array
        return this.setState((prevState) => {
          const checkedFilters = Object.assign({}, prevState.checkedFilters, {
            customFilter: data,
          });
          return { checkedFilters };
        });
      case "discard":
        // "Discard", viewFilters off and clear customFilter
        return this.setState((prevState) => {
          const checkedFilters = Object.assign({}, prevState.checkedFilters, {
            customFilter: [],
          });
          return { checkedFilters, viewFilters: false };
        });
      default:
        // "Save" case, viewFilters off, all filters off except customFilter
        return this.setState((prevState) => {
          const checkedFilters = Object.assign({}, prevState.checkedFilters, {
            allFilter: false,
            primaryFilter: false,
            secondaryFilter: false,
            assistantFilter: false,
          });
          return { checkedFilters, viewFilters: false };
        });
    }
  }

  handleLoadSwitch(e) {
    e.preventDefault();

    this.setState(({ loadSwitch }) => ({
      loadSwitch: Object.assign({}, loadSwitch, {
        percent: !loadSwitch.percent,
      }),
    }));
  }

  handleClearAll(e) {
    e.preventDefault();
    this.setState(({ data }) => ({
      progressions: {},
      checkedProgression: {
        loadProgression: false,
        rpeProgression: false,
        repsProgression: false,
        setsProgression: false,
      },
      checkedFilters: {
        allFilter: true,
        primaryFilter: false,
        secondaryFilter: false,
        assistantFilter: false,
        customFilter: [],
      },
      data: { ...data, to: [] },
      submited: false,
    }));
    document.getElementById("duplicate-workout-form")?.reset?.();
  }

  render() {
    const { weeksOrder, sessions } = this.props;
    const {
      checkedProgression,
      checkedFilters,
      data,
      loadSwitch,
      progressions,
    } = this.state;
    const {
      locals: { activeUserToRequest },
    } = this.context;

    const { from, isExercise } = data;
    const {
      loadProgression,
      rpeProgression,
      setsProgression,
      repsProgression,
    } = checkedProgression;
    const {
      allFilter,
      primaryFilter,
      secondaryFilter,
      assistantFilter,
      customFilter,
    } = checkedFilters;

    const intensityMeasure =
      get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
        ? "RPE"
        : "RiR";

    let exName,
      exType = "";
    if (isExercise) {
      const { secondary, primary, type } = this.exercise;
      exName = secondary ? secondary + "(" + primary + ")" : primary;
      exType = type;
    }

    const loadLabel = loadSwitch.percent ? "%" : loadSwitch.units;
    const disabledProgression =
      !loadProgression &&
      !rpeProgression &&
      !repsProgression &&
      !setsProgression;

    if (this.state.viewFilters) {
      return (
        <CustomFilters
          exercises={this.exercisesList}
          customFilter={customFilter}
          updateCustomFilter={this.updateCustomFilter}
        />
      );
    }

    return (
      <form
        onSubmit={(e) => this.handleDuplicate(e)}
        data-noreset
        id="duplicate-workout-form"
      >
        <Modal
          toClear={["session", "week"]}
          title={`${
            isExercise
              ? "Duplicate Exercise"
              : `Duplicate Week ${from.week} Workout ${from.session}`
          }`}
          className="duplicate-workout-modal"
        >
          <div className="body">
            {isExercise && (
              <div className="flex items-center gap-1 mb-6">
                <p className="s1">Duplicate Week {from.week}</p>
                <span className="s1">{">>"}</span>
                <p className="s1 clipped w-fit">
                  Workout {from.session} {">"} {exName}
                </p>
              </div>
            )}
            <div className="progression-toggle">
              {exType !== "assistant" &&
                (!assistantFilter || secondaryFilter || primaryFilter) && (
                  <LoadProgression
                    handleCheck={this.handleCheck}
                    handleLoadSwitch={this.handleLoadSwitch}
                    loadSwitch={loadSwitch}
                    checked={loadProgression}
                  />
                )}

              <ProgressionCheckbox
                name="repsProgression"
                onChange={this.handleCheck}
                checked={repsProgression}
              >
                Add progressions to Reps
              </ProgressionCheckbox>

              <ProgressionCheckbox
                name="rpeProgression"
                onChange={this.handleCheck}
                checked={rpeProgression}
              >
                Add progressions to {intensityMeasure} (0.5 incr)
              </ProgressionCheckbox>

              <ProgressionCheckbox
                name="setsProgression"
                onChange={this.handleCheck}
                checked={setsProgression}
              >
                Add progressions to Sets
              </ProgressionCheckbox>
            </div>

            {!isExercise && (
              <div
                className={`progression-filter ${
                  disabledProgression ? " disabled" : ""
                }`}
              >
                <span>Exercise Type Progression Filter</span>
                <ul>
                  <ProgressionCheckbox
                    name="allFilter"
                    checked={allFilter}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    All
                  </ProgressionCheckbox>
                  <ProgressionCheckbox
                    name="primaryFilter"
                    checked={primaryFilter}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    Primary Lift
                  </ProgressionCheckbox>
                  <ProgressionCheckbox
                    name="secondaryFilter"
                    checked={secondaryFilter}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    Variations
                  </ProgressionCheckbox>
                  <ProgressionCheckbox
                    name="assistantFilter"
                    checked={assistantFilter}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    Accessories
                  </ProgressionCheckbox>
                  <ProgressionCheckbox
                    name="customFilter"
                    checked={customFilter.length > 0}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    Custom filter ({customFilter.length})
                  </ProgressionCheckbox>
                </ul>
              </div>
            )}

            {map(sessions, (sessionGroup, order) => {
              return (
                <div key={`workout-${order}`} className="progressions-wrapper">
                  <div className={`progression-workout workout-${order}`}>
                    <p className="s1">Workout {order}</p>
                    {exType !== "assistant" &&
                      (!assistantFilter ||
                        secondaryFilter ||
                        primaryFilter) && (
                        <p className={`p2 ${loadProgression}`}>
                          Load ({loadLabel}){" "}
                        </p>
                      )}
                    <p className={`p2 ${rpeProgression}`}>
                      {intensityMeasure} (0.5 incr)
                    </p>
                    <p className={`p2 ${repsProgression}`}>Reps</p>
                    <p className={`p2 ${setsProgression}`}>Sets</p>
                  </div>
                  <div className="progression-weeks">
                    {map(weeksOrder, (week) => {
                      const session = find(
                        sessionGroup,
                        (sess) => sess.order == order && sess.week == week
                      );
                      if (!session) return <div key={`${week}-${order}`} />;
                      const value = JSON.stringify({
                        week: session.week,
                        session: session.order,
                      });
                      const disabled =
                        !isExercise && this.shouldDisable(session);
                      return (
                        <div key={`${week}-${order}`}>
                          {order == 1 && <p className="s1 mb-2">Week {week}</p>}
                          <ProgressionCheckbox
                            value={value}
                            disabled={disabled}
                            onChange={this.toggleSelection}
                            checked={data.to.some(
                              (item) => JSON.stringify(item) == value
                            )}
                          />

                          {exType !== "assistant" &&
                            (!assistantFilter ||
                              secondaryFilter ||
                              primaryFilter) && (
                              <ProgressionInput
                                disabled={disabled}
                                step="0.5"
                                placeholder={`Load (${loadLabel})`}
                                name={`${session.week}_${session.order}_progression_load`}
                                onInput={this.handleProgressionInput}
                                progressions={progressions}
                                unchecked={!loadProgression}
                              />
                            )}

                          <ProgressionInput
                            disabled={disabled}
                            name={`${session.week}_${session.order}_progression_rpe`}
                            onInput={this.handleProgressionInput}
                            isRpe
                            progressions={progressions}
                            unchecked={!rpeProgression}
                          />

                          <ProgressionInput
                            disabled={disabled}
                            step="1"
                            placeholder="Reps"
                            name={`${session.week}_${session.order}_progression_reps`}
                            onInput={this.handleProgressionInput}
                            progressions={progressions}
                            unchecked={!repsProgression}
                          />

                          <ProgressionInput
                            disabled={disabled}
                            step="1"
                            placeholder="Sets"
                            name={`${session.week}_${session.order}_progression_sets`}
                            onInput={this.handleProgressionInput}
                            progressions={progressions}
                            unchecked={!setsProgression}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          <DuplicateModalFooter
            disabled={data.to.length === 0}
            onClear={this.handleClearAll}
          />
        </Modal>
      </form>
    );
  }
}

DuplicateWorkoutModal.contextTypes = { locals: PropTypes.object };

export default DuplicateWorkoutModal;
